import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { IRootState } from '@bca-store/store.reducers';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Prevents the user from deactivating
 * the current route if any dialog is open
 */
@Injectable()
export class DialogOpenGuard implements CanDeactivate<any> {
  constructor(private _store$: Store<IRootState>) {}
  canDeactivate(): Observable<boolean> {
    return this._store$.pipe(select(({ app }) => app.dialogStatus)).pipe(
      take(1),
      map(dialog => !Object.keys(dialog).some(key => dialog[key]))
    );
  }
}
